import { render, staticRenderFns } from "./paasInitOrder.vue?vue&type=template&id=64bd81f8&scoped=true&"
import script from "./paasInitOrder.vue?vue&type=script&lang=js&"
export * from "./paasInitOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd81f8",
  null
  
)

export default component.exports